var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"not-found"},[_c('div',{staticClass:"icon"},[_vm._v("🚧")]),_c('PageHeader',{attrs:{"title":"Unser Shop befindet sich gerade im Umbau. Wir sind bald wieder da!"}})],1),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }